module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "fs",
    attrs: {
      "id": "page024"
    }
  }, [_c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page024_1"
    }
  }, [_vm._v("OLIVE PASTE")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page024_2"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("âte d")]), _vm._v("’O"), _c('span', {
    staticClass: "small1"
  }, [_vm._v("live")])]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page024_3"
    }
  }, [_vm._v("TIME REQUIRED:")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page024_4"
    }
  }, [_vm._v("1.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page024_4a"
    }
  }, [_c('span', {
    staticClass: "page024_4a"
  }, [_vm._v(" Coarsely chop the olives and capers and combine in a blending")])]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page024_5"
    }
  }, [_vm._v("10 minutes")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page024_6"
    }
  }, [_vm._v("beaker with the mustard. Purée with a hand-held blender while")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page024_7"
    }
  }, [_vm._v("gradually incorporating the oil.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page024_8"
    }
  }, [_vm._v("70 g pitted black olives")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page024_9"
    }
  }, [_vm._v("2.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page024_9a"
    }
  }, [_c('span', {
    staticClass: "page024_9a"
  }, [_vm._v("Season with salt and pepper.")])]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page024_10"
    }
  }, [_vm._v("20 g capers")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page024_11"
    }
  }, [_vm._v("Tip:")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page024_11a"
    }
  }, [_c('span', {
    staticClass: "page024_11a"
  }, [_vm._v(" Olives are green before they ripen, later darkening and")])]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page024_12"
    }
  }, [_vm._v("1 tsp Dijon mustard")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page024_13"
    }
  }, [_vm._v("turning black. The tastiest are the small, black Niçoise olives.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page024_14"
    }
  }, [_vm._v("3 tbsp olive oil")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page024_15"
    }
  }, [_vm._v("Salt, pepper")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page024_16"
    }
  }, [_vm._v("B"), _c('span', {
    staticClass: "pagen"
  }, [_vm._v("asics")])]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page024_0"
    }
  }, [_vm._v("24")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-604fd0b4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page_024.vue
// module id = 126
// module chunks = 0